require('./bootstrap');

import { Inertia } from '@inertiajs/inertia';
import { App } from '@inertiajs/inertia-svelte';
import Layout from '~/pages/Layout.svelte';
import AdminLayout from '~/pages/admin/Layout.svelte';

// Inertia.on('navigate', (event) => {
//   if (window.dataLayer) {
//     window.dataLayer.push({
//       'url': event.detail.page.url,
//       'event': 'pageview'
//     });
//   }
// })

const el = document.getElementById('app');

new App({
  target: el,
  props: {
    initialPage: JSON.parse(el.dataset.page),
    resolveComponent: name => import(`./pages/${name}.svelte`)
      .then(page => {
        if (page.layout === undefined) {
          if (name.startsWith('admin/')) {
            page.layout = AdminLayout;
          } else {
            page.layout = Layout;
          }
        }
        return page;
      }),
  },
});
